import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { User } from 'firebase/auth';
import CrewFeedItem from '../widgets/CrewFeedItem';
import { font } from '../../utils/fontHelper';
import type { CrewFeedItem as CrewFeedItemModel } from '../../utils/crewFeedUtils';

export interface CrewPostComposePreviewPanelProps {
  item: CrewFeedItemModel;
  actorName: string;
  actorAvatar?: string;
  currentUser?: User | null;
  /** Shown under the section title when pinning is enabled (compose preview). */
  pinSummary?: string | null;
}

/**
 * Full-width preview of a draft official Crew post using the same row component as the live feed.
 */
export const CrewPostComposePreviewPanel: React.FC<CrewPostComposePreviewPanelProps> = ({
  item,
  actorName,
  actorAvatar,
  currentUser,
  pinSummary,
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box>
      <Typography sx={{ fontFamily: font(), fontWeight: 700, fontSize: 12, color: 'text.secondary', mb: 1.5, letterSpacing: 0.5 }}>
        CREW FEED
      </Typography>
      <Typography sx={{ fontFamily: font(), fontSize: 13, color: 'text.secondary', mb: 1 }}>
        Appears with other Crew activity, attributed to Watchlist Crew. Linked content loads live data after publishing.
      </Typography>
      {pinSummary ? (
        <Typography sx={{ fontFamily: font(), fontSize: 13, color: 'warning.main', fontWeight: 600, mb: 1.5 }}>
          {pinSummary}
        </Typography>
      ) : null}
      <Box
        sx={{
          borderRadius: 2,
          border: `1px solid ${isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)'}`,
          bgcolor: theme.palette.background.default,
          px: { xs: 0, sm: 1 },
          pt: 1,
          overflow: 'hidden',
        }}
      >
        <CrewFeedItem
          item={item}
          actorName={actorName}
          actorAvatar={actorAvatar}
          currentUser={currentUser}
        />
      </Box>
    </Box>
  );
};
